var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF5917",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 26V24.6667C23.3332 23.9594 23.0522 23.2811 22.5521 22.781C22.052 22.281 21.3737 22 20.6665 22H15.3332C14.6259 22 13.9476 22.281 13.4476 22.781C12.9475 23.2811 12.6665 23.9594 12.6665 24.6667V26",
    stroke: "#FF5917",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 19.3333C19.4724 19.3333 20.6663 18.1394 20.6663 16.6667C20.6663 15.1939 19.4724 14 17.9997 14C16.5269 14 15.333 15.1939 15.333 16.6667C15.333 18.1394 16.5269 19.3333 17.9997 19.3333Z",
    stroke: "#FF5917",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.333 26V24.6667C27.3326 24.0758 27.1359 23.5019 26.7739 23.0349C26.4119 22.5679 25.9051 22.2344 25.333 22.0867",
    stroke: "#FF5917",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 14.0867C23.2401 14.2335 23.7485 14.5671 24.1116 15.0349C24.4747 15.5026 24.6717 16.0779 24.6717 16.67C24.6717 17.2621 24.4747 17.8374 24.1116 18.3051C23.7485 18.7729 23.2401 19.1065 22.6665 19.2533",
    stroke: "#FF5917",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.0af6e849b65642c6de230b937b2fcac3.svg";
export { ForwardRef as ReactComponent };